import Postmate from '@regily/regily-postmate'
import { getDynamicSettings, getQueryParams } from '../utils/browserStructure'

export function openAffiliate () {
  const script = document.currentScript || document.querySelector('script[src*=".regily.com/"]')
  const urlParams = getQueryParams(script.src)

  let regilyIframeWrapper = document.querySelector('#regily-proxy-frame')
  if (!regilyIframeWrapper) {
    regilyIframeWrapper = document.createElement('div')
    regilyIframeWrapper.name = 'regily-proxy-frame'
    regilyIframeWrapper.id = 'regily-proxy-frame'

    regilyIframeWrapper.style.position = 'absolute'
    regilyIframeWrapper.style.left = '10000px'
    regilyIframeWrapper.style.top = '10000px'

    document.body.appendChild(regilyIframeWrapper)
  }

  const partnerRegistrationUrl = decodeURIComponent(urlParams.partnerRegistrationUrl) || urlParams.partnerRegistrationUrl
  const encodedOrigin = urlParams.encodedOrigin

  const containerUrl = new URL(partnerRegistrationUrl)
  containerUrl.searchParams.set('regilyRemote', 'true')

  containerUrl.searchParams.set('remoteOrigin', encodedOrigin)

  // For testing purpose only
  if (urlParams.simulateSlowConnection && urlParams.simulateSlowConnection !== 'null') {
    containerUrl.searchParams.set('simulateSlowConnection', 'true')
  }

  let handshake
  try {
    handshake = new Postmate({
      container: regilyIframeWrapper,
      url: containerUrl.href,
      childOriginHandshake: '*' // Accepts '*' or the origin where the postmate handshake will be emitted
    })
  } catch (error) {
    console.log(error)
  }

  return {
    handshake,
    config: urlParams
  }
}

export function openPostmate () {
  const handshake = new Postmate.Model({
    data: {},
    dataDiff: {},
    dynamicSettings: getDynamicSettings(),
    regilyUpdateCallbackData: ({ data, dataDiff }) => {
      handshake.data = data
      handshake.dataDiff = dataDiff
    },
    regilyUpdateCallback: () => new Promise((resolve) => {
      const isCallbackPresent = typeof window['regilyUpdateCallback'] === 'function'

      if (isCallbackPresent) {
        window['regilyUpdateCallback'](handshake.data, handshake.dataDiff).then(response => {
          resolve(response)
        }, error => {
          const errorResponse = {
            error: {}
          }
          errorResponse.error = Object.assign({}, error)
          errorResponse.error.message = error.message

          resolve(errorResponse)
        })
      }
    }),
    regilyDoneCallbackData: ({ data, dataDiff }) => {
      handshake.data = data
    },
    regilyDoneCallback: () => new Promise((resolve) => {
      const isCallbackPresent = typeof window['regilyCallback'] === 'function' || typeof window['regilyDoneCallback'] === 'function'

      if (isCallbackPresent) {
        window['regilyDoneCallback'](handshake.data).then(response => {
          resolve(response)
        }, error => {
          const errorResponse = {
            error: {}
          }
          errorResponse.error = Object.assign({}, error)
          errorResponse.error.message = error.message

          resolve(errorResponse)
        })
      } else {
        resolve(true)
      }
    })
  })
}

export function updateModuleSettings (postmate, settings) {
  postmate.call('updateRemoteSettings', { settings })
  postmate.call('showRemoteNotification')
}

export function attachCallback (type, postmate, successHandler) {
  const callback = (data, dataDiff) => {
    postmate.call(`${type}Data`, { data, dataDiff })

    return new Promise((resolve, reject) => {
      postmate.get(type).then((response) => {
        console.info(`${type} resolved on proxy`)

        const errorData = response && response.error
        if (errorData) {
          const errorTitle = errorData.title
          const errorMessage = errorData.message
          const errorType = errorData.name
          const error = new Error(errorMessage)
          error.name = errorType
          error.title = errorTitle
          reject(error)
          return
        }

        if (successHandler) {
          setTimeout(() => {
            successHandler()
          }, 100)
        }
        resolve(response)
      })
    })
  }

  // attach callback
  Object.defineProperty(window, type, {
    writable: true,
    value: callback
  })
}

export function remoteHandshakeHandler (partner) {
  let isModuleReady = false
  let isRemoteSettingUpdated = false
  let isRemoteSettingLoaded = false
  let remoteSettings = {}
  let moduleLanguage = null

  const affiliate = openAffiliate()

  if (affiliate.config.lang && affiliate.config.lang !== 'null') {
    moduleLanguage = affiliate.config.lang
  }

  // Launch the module from the affiliate website with pre-defined settings
  partner.start({regilyRemote: 'true', waitForRemoteConnection: 'true', regilyLanguage: moduleLanguage})

  // wait for the module postmate to be ready before updating the module settings
  window.addEventListener('message', function _moduleReadyListener () {
    if (event.data && event.data.postmate && event.data.postmate === 'emit' && event.data.value && event.data.value.name === 'moduleReady') {
      isModuleReady = true
      if (!isRemoteSettingUpdated && isRemoteSettingLoaded) {
        updateModuleSettings(partner.postmate, remoteSettings)
      }
    }

    if (event.data && event.data.postmate && event.data.postmate === 'emit' && event.data.value && event.data.value.name === 'redirectToLoginRemote') {
      parent.postMessage({ name: 'remote-redirect', url: event.data.value.data }, '*')
    }
  })

  affiliate.handshake.then((child) => {
    const partnerRedirectUrl = decodeURIComponent(affiliate.config.partnerRedirectUrl) || affiliate.config.partnerRedirectUrl
    attachCallback('regilyUpdateCallback', child)
    attachCallback('regilyDoneCallback', child, () => {
      if (partnerRedirectUrl) {
        const redirectURL = new URL(partnerRedirectUrl)
        parent.postMessage({ name: 'remote-redirect', url: redirectURL.href }, '*')
      }
    })

    child.get('dynamicSettings')
      .then((settings) => {
        isRemoteSettingLoaded = true

        settings.regilySofortUrl = partnerRedirectUrl
        settings.regilyRemoteLoading = false
        remoteSettings = settings

        if (isModuleReady) {
          updateModuleSettings(partner.postmate, remoteSettings)
          isRemoteSettingUpdated = true
        }
      })
  })
}



// WEBPACK FOOTER //
// ./src/partners/remote.js